import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "count"]

  updateCount() {
    const checked = this.cardTargets.filter(card => card.querySelector("input:checked"))
    this.countTarget.textContent = checked.length
  }
}
